module.exports = __webpack_public_path__ + "img/Candy Treats.b8e31e4e.jpg";